module.exports = __webpack_public_path__ + "img/placeholder-4.58f79906.jpg";